import { useSelector } from 'react-redux';
import { getBrandKitId } from 'ContentData/selectors/branding';
import Routes from 'ContentUtils/Routes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { LinkIcon, UnlinkIcon } from 'foundations-assets';
import UIIconButton from 'UIComponents/button/UIIconButton';
import InheritanceTypes from 'ContentUtils/constants/CustomWidgetInheritanceTypes';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.${key}`;
const IconWrapper = styled.span.withConfig({
  displayName: "FieldInheritanceIcon__IconWrapper",
  componentId: "sc-1qc6xqf-0"
})(["vertical-align:middle;"]);
const FieldInheritanceIcon = ({
  inheritedValue,
  isDefaultValue,
  onResetClick,
  onUnlinkClick,
  scrollToField,
  themePath
}) => {
  const {
    inheritanceType,
    inheritanceFieldKey,
    inheritanceFieldLabel
  } = inheritedValue || {};
  const brandKitId = useSelector(getBrandKitId);
  if (!inheritanceType) return null;
  let tooltipTitle;

  // If default value was overridden, display "Reset" tooltip
  if (!isDefaultValue) {
    tooltipTitle = inheritanceType === InheritanceTypes.brandSettings ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('inheritanceTooltip.reset.brandSettings')
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('inheritanceTooltip.reset.default')
    });
  }

  // Link to brand kit if inheriting from brand settings
  if (inheritanceType === InheritanceTypes.brandSettings) {
    tooltipTitle = /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('inheritanceTooltip.brandSettings_jsx'),
      options: {
        href: Routes.brandSettings(brandKitId)
      },
      elements: {
        Link: UILink
      }
    });
    // If inheriting from theme settings and theme path is given, link to theme editor
  } else if (inheritanceType === InheritanceTypes.theme && themePath) {
    tooltipTitle = inheritanceFieldLabel ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('inheritanceTooltip.themeEditorField_jsx'),
      options: {
        href: Routes.themeEditor(themePath, {
          scrollToField: inheritanceFieldKey.join('.')
        }),
        inheritanceFieldLabel
      },
      elements: {
        Link: UILink
      }
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('inheritanceTooltip.themeEditor_jsx'),
      options: {
        href: Routes.themeEditor(themePath)
      },
      elements: {
        Link: UILink
      }
    });
    // Otherwise, if inheriting from another field display which field that is
  } else if (inheritanceFieldLabel) {
    tooltipTitle = scrollToField ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('inheritanceTooltip.field_jsx'),
      options: {
        onClick: () => {
          scrollToField({
            fieldKey: inheritanceFieldKey
          });
        },
        inheritanceFieldLabel
      },
      elements: {
        Link: UILink
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('inheritanceTooltip.field'),
      options: {
        inheritanceFieldLabel
      }
    });
  }
  return tooltipTitle ? /*#__PURE__*/_jsx(IconWrapper, {
    children: /*#__PURE__*/_jsx(UIIconButton, {
      className: "m-left-1",
      onClick: isDefaultValue ? onUnlinkClick : onResetClick,
      size: "sm",
      tooltip: tooltipTitle,
      use: "link",
      children: isDefaultValue ? /*#__PURE__*/_jsx(LinkIcon, {}) : /*#__PURE__*/_jsx(UnlinkIcon, {})
    })
  }) : null;
};
export default FieldInheritanceIcon;